import type { User } from '../types'

export const OWNER_PLACEHOLDER = 'Select owner...'
export const NO_ELIGIBLE_OWNERS_MESSAGE = 'No eligible owners available.'

/**
 * Team member lists are already the server's eligibility boundary for an
 * action-item owner. Only use the current user as a default when that user is
 * actually present in the list; falling back to an id that has no option in a
 * select creates an invalid, invisible selection.
 */
export function defaultActionItemOwnerId(
  teamMembers: readonly User[] | null | undefined,
  currentUserId: number | null | undefined,
): string {
  if (
    currentUserId != null &&
    (teamMembers ?? []).some(member => member.id === currentUserId)
  ) {
    return String(currentUserId)
  }

  return ''
}